import { Stack, StackProps, Typography } from '@mui/material';
import { Action, ScheduledActionFragmentFragment } from '../../api/gql';
import { ActionIcon } from './ScheduledActionIcon';

type ScheduledActionsProps = StackProps & {
  scheduledActions: ScheduledActionFragmentFragment[];
  size?: 'small' | 'medium';
};
export const ScheduledActions = ({ scheduledActions, size = 'small', ...rest }: ScheduledActionsProps) => {
  const grouped = scheduledActions.reduce(
    (acc, action) => {
      acc[action.action].total += 1;
      if (action.doneAt) {
        acc[action.action].done += 1;
      }
      return acc;
    },
    {
      [Action.Sms]: { done: 0, total: 0 },
      [Action.Email]: { done: 0, total: 0 },
      [Action.Call]: { done: 0, total: 0 },
    },
  );

  return (
    <Stack {...rest} direction={'row'} spacing={size === 'small' ? 2 : 4}>
      {Object.values(Action)
        .sort((a, b) => (b === Action.Call ? -1 : 1))
        .map((action) => (
          <Stack key={action} direction={'row'} spacing={0.5} minWidth={50}>
            <ActionIcon action={action} fontSize={size} color={grouped[action].total ? 'primary' : 'disabled'} />
            <Typography
              variant={size === 'small' ? 'caption' : undefined}
              color={grouped[action].total ? undefined : 'text.disabled'}
            >
              {grouped[action].done}/{grouped[action].total}
            </Typography>
          </Stack>
        ))}
    </Stack>
  );
};
